const CONFIG = require('./rest-api.json')

var envType = process.env.NODE_ENV

if (window.location.href.indexOf('dev2.') > -1) {
  CONFIG.BASE_API = CONFIG.DEV2BASE_API;
} else if (window.location.href.indexOf('dev3.') > -1) {
  CONFIG.BASE_API = CONFIG.DEV3BASE_API;
} else if (envType == 'production') {
  CONFIG.BASE_API = CONFIG.PRODBASE_API;
} else if (envType == 'development') {
  CONFIG.BASE_API = process.env.REACT_APP_BASE_API
    ? process.env.REACT_APP_BASE_API
    : CONFIG.BASE_API;
}
module.exports = CONFIG;
